module.exports = "<a [routerLink]=\"['/inicio']\">\r\n  <img src=\"./assets/img/404.png\" \r\n       class=\"center-block\" \r\n       style=\"width: 65%\" />\r\n    </a>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/pagina-404/pagina-404.component.html
// module id = ../../../../../src/app/components/pagina-404/pagina-404.component.html
// module chunks = main